export default {
  discount_types: {
    cashback: 'Punkty lojalnościowe',
    promo_code: 'Kod promocyjny',
  },
  input: {
    label: '{{cashbackLabel}} lub {{promoCodeLabel}}',
    placeholder: 'Kod promocyjny',
  },
  buttons: {
    apply: 'Zastosuj',
    remove: 'Usuń',
  },
  feedback: {
    login:
      '<highlight>Zaloguj się</highlight>, aby użyć tego kodu promocyjnego — musimy sprawdzić, czy nie był już używany. Zaloguj się i spróbuj ponownie.',
    usage_threshold: 'Minimalna kwota koszyka dla tej promocji wynosi (bez kosztów dostawy)',
    promo_code_added: 'Kod promocyjny został pomyślnie zastosowany',
  },
};
